import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Navigation from '../components/Navigation';
import { logoutUser } from 'redux-modules/modules/user';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state) => ({
    store: state
});

const mapDispatchToProps = (dispatch, props) => ({
    logout: bindActionCreators(logoutUser, dispatch),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation));



// WEBPACK FOOTER //
// ./src/containers/NavigationContainer.js